namespace GeniuzPOS.PosShift {
    export class PsVatRefundColumns {
        static columnsKey = 'PosShift.PsVatRefund';
    }
}
